export const BULK_VALIDATE_REQUEST = 'BULK_VALIDATE_REQUEST';
export const validate = (fulfillmentPlanIds) => ({
  type: BULK_VALIDATE_REQUEST,
  fulfillmentPlanIds,
});

export const BULK_VALIDATE_REQUEST_SUCCESS = 'BULK_VALIDATE_REQUEST_SUCCESS';
export const validateSuccess = (jobGuid, includedFulfillmentPlanIds, excludedFulfillmentPlanIds, andPrint) => ({
  type: BULK_VALIDATE_REQUEST_SUCCESS,
  jobGuid,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  andPrint,
});

export const BULK_RESET_FOR_ERRORS_AND_WARNINGS = 'BULK_RESET_FOR_ERRORS_AND_WARNINGS';
export const bulkResetForErrorsAndWarnings = (jobGuid, includedFulfillmentPlanIds, excludedFulfillmentPlanIds, andPrint) => ({
  type: BULK_RESET_FOR_ERRORS_AND_WARNINGS,
  jobGuid,
  includedFulfillmentPlanIds,
  excludedFulfillmentPlanIds,
  andPrint,
});

export const BULK_VALIDATE_ASSIGN_NEW_JOB_ID = 'BULK_VALIDATE_ASSIGN_NEW_JOB_ID';
export const bulkValidateAssignNewJobId = (initialValidationJobId, newJobId) => ({
  type: BULK_VALIDATE_ASSIGN_NEW_JOB_ID,
  initialValidationJobId,
  newJobId,
});

export const BULK_VALIDATE_REQUEST_FAILURE = 'BULK_VALIDATE_REQUEST_FAILURE';
export const validateFailure = (error) => ({
  type: BULK_VALIDATE_REQUEST_FAILURE,
  error,
});

export const BULK_BATCH_VALIDATED_CLEAR = 'BULK_BATCH_VALIDATED_CLEAR';
export const clearBatchValidated = (jobGuid) => ({
  type: BULK_BATCH_VALIDATED_CLEAR,
  jobGuid,
});

export const BULK_BATCH_VALIDATED_EVERYTHING_IS_ERRORABLE = 'BULK_BATCH_VALIDATED_EVERYTHING_IS_ERRORABLE';
export const validationEverythingIsAnError = () => ({
  type: BULK_BATCH_VALIDATED_EVERYTHING_IS_ERRORABLE,
});

export const BULK_START_PROCESSING_COST_REVIEW = 'BULK_START_PROCESSING_COST_REVIEW';
export const startProcessingCostReview = (jobGuid, included, excluded, errored, andPrint, shouldShowLegacyCostReview = false) => ({
  type: BULK_START_PROCESSING_COST_REVIEW,
  jobGuid,
  included,
  excluded,
  errored,
  andPrint,
  shouldShowLegacyCostReview,
});

export const BULK_CLEAR_COST_REVIEW = 'BULK_CLEAR_COST_REVIEW';
export const clearCostReview = (jobGuid) => ({
  type: BULK_CLEAR_COST_REVIEW,
  jobGuid,
});

export const BULK_PURCHASE_LABEL_SUCCESS = 'BULK_PURCHASE_LABEL_SUCCESS';
export const bulkPurchaseLabelSuccess = (included, excluded, errored, batches, andPrint, metadata) => ({
  type: BULK_PURCHASE_LABEL_SUCCESS,
  included,
  excluded,
  errored,
  batches,
  andPrint,
  metadata,
});

export const BULK_PURCHASE_LABEL_FAILURE = 'BULK_PURCHASE_LABEL_FAILURE';
export const bulkPurchaseLabelFailure = (fulfillmentPlanIds, errors, metadata = {}) => ({
  type: BULK_PURCHASE_LABEL_FAILURE,
  fulfillmentPlanIds,
  errors,
  metadata,
});

export const BULK_PROCESSING_CREATE_LABEL_MESSAGE = 'BULK_PROCESSING_CREATE_LABEL_MESSAGE';
export const messageReceivedCreateLabel = (message) => ({
  type: BULK_PROCESSING_CREATE_LABEL_MESSAGE,
  message,
});

export const BULK_PROCESSING_CREATE_LABEL_FINAL_MESSAGE = 'BULK_PROCESSING_CREATE_LABEL_FINAL_MESSAGE';
export const createLabelBatchLastMessage = (batchId, message) => ({
  type: BULK_PROCESSING_CREATE_LABEL_FINAL_MESSAGE,
  batchId,
  message,
});

export const BULK_END_PROCESSING_CREATE_LABEL = 'BULK_END_PROCESSING_CREATE_LABEL';
export const finishProcessingCreateLabel = (included, excluded, errored, andPrint, metadata) => ({
  type: BULK_END_PROCESSING_CREATE_LABEL,
  included,
  excluded,
  errored,
  andPrint,
  metadata,
});

export const BULK_PROCESSING_CREATE_LABEL_MARK_BATCH_PROCESSED = 'BULK_PROCESSING_CREATE_LABEL_MARK_BATCH_PROCESSED';
export const markLabelBatchProcessed = (batchGroupKey, remainingBatches) => ({
  type: BULK_PROCESSING_CREATE_LABEL_MARK_BATCH_PROCESSED,
  batchGroupKey,
  remainingBatches,
});

export const BULK_CLEAR_CREATE_LABEL = 'BULK_CLEAR_CREATE_LABEL';
export const clearCreateLabel = (batchGroupKey) => ({
  type: BULK_CLEAR_CREATE_LABEL,
  batchGroupKey,
});

export const BULK_IGNORE_SHIPSURANCE_TERMS_AND_CONDITIONS = 'BULK_IGNORE_SHIPSURANCE_TERMS_AND_CONDITIONS';

export const ignoreShipsuranceTermsAndConditions = (jobGuid) => ({
  type: BULK_IGNORE_SHIPSURANCE_TERMS_AND_CONDITIONS,
  jobGuid,
});

export const BULK_PROCESSING_FULFILLMENT_UNKNOWN_ERROR = 'BULK_PROCESSING_FULFILLMENT_UNKNOWN_ERROR';
export const bulkProcessingUnknownError = (batchId, message) => ({
  type: BULK_PROCESSING_FULFILLMENT_UNKNOWN_ERROR,
  batchId,
  message,
});

export const BULK_SET_SHIP_DATE = 'BULK_SET_SHIP_DATE';
export const bulkSetShipDate = (shipDate) => ({
  type: BULK_SET_SHIP_DATE,
  shipDate,
});

export const BULK_SET_ACTIVE_LABEL_BATCH_STATUS_STEP = 'BULK_SET_ACTIVE_LABEL_BATCH_STATUS_STEP';
export const bulkSetActiveLabelBatchStatusStep = (stepData) => ({
  type: BULK_SET_ACTIVE_LABEL_BATCH_STATUS_STEP,
  stepData,
});

export const BULK_SET_LABEL_PROCESSING_ERROR = 'BULK_SET_LABEL_PROCESSING_ERROR';
export const bulkSetLabelProcessingEror = (error) => ({
  type: BULK_SET_LABEL_PROCESSING_ERROR,
  error,
});

export const BULK_UPDATE_JOB_ERROR_AND_WARNINGS = 'BULK_UPDATE_JOB_ERROR_AND_WARNINGS';
export const bulkUpdateJobErrorAndWarnings = (jobGuid, errorsAndWarnings) => ({
  type: BULK_UPDATE_JOB_ERROR_AND_WARNINGS,
  jobGuid,
  errorsAndWarnings,
});
